module.exports = __webpack_public_path__ + "static/media/swap-img.c2daca57.png";